export default __webpack_public_path__ + "static/orange-d3da4bda073d07034851c806b2f6c0a3.png";